import styled from 'styled-components';

import { ArticleSection } from 'editorial/components/ArticleSection';
import { ArticleVideo } from 'editorial/components/ArticleVideo';
import { IArticleSectionAdditionalProps, IArticleVideo } from 'editorial/types';

export const ArticleFullVideo = ({
  videos,
  text,
  theme,
}: IArticleVideo & IArticleSectionAdditionalProps) => {
  return (
    <ArticleSection hasImage>
      <ArticleFullVideo.Wrapper>
        <ArticleVideo video={videos[0]} text={text} theme={theme} />
      </ArticleFullVideo.Wrapper>
    </ArticleSection>
  );
};

ArticleFullVideo.Wrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 999999px;
`;
